import React, {useContext, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as GiftSVG} from "../../../../../images/icons/gift-solid.svg";
import {ReactComponent as PlusSVG} from "../../../../../images/icons/plus.svg";
import {ReactComponent as RemoveSVG} from "../../../../../images/icons/remove.svg";
import {ReactComponent as CalendarSVG} from "../../../../../images/icons/calendar.svg";
import {RootState} from "../../../../../reducers";
import handleException from "../../../../services/Api/handleException";
import {useCart} from "../../../../services/Cart/cartService";
import VoucherModal from "../../../Navbar/UserDrawer/VoucherModal";
import {getAvailabilities, getCategories, getItems, getMenus, getPromotions} from "../../../../services/Menu/reducer";
import {getSession} from "../../../../services/Session/reducer";
import {getCart} from "../../../../services/Cart/reducer";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {DateHelper, formatDate} from "../../../../services/Common/Date/DateHelper";
import {VoucherProductsContext} from "../../../../services/VoucherProducts/VoucherProductsContext";

interface OwnProps {
    setPage: (page?: string) => void,
    voucher: any,
    promotion_id?: number,
    onSuccess: (voucher?: any) => void,
    options?: string[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function VoucherSingleComponent(props: Props) {
    const [modal, setModal] = useState(false);
    const voucher = props.voucher;
    const product = voucher.product;
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState<any[]>([]);
    let cartService = useCart();
    const isLocationSelected = true;
    const {t} = useTranslation();
    const {handlePromotionChange} = useContext(VoucherProductsContext);


    const addVoucher = async () => {
        setLoading(true);
        if (!isLocationSelected) {
            setLoading(false);
            setErrors([{
                message: "Wybierz najpierw lokal aby dodać voucher do zamówienia"
            }]);
            return;
        }
        try {
            await cartService.addOrderVoucher(voucher.code);
            setLoading(false);
            if (props.onSuccess) props.onSuccess();
            // navigate(AppConfig.getLinkWithPrefix("/", prefix));
        } catch (e) {
            console.log(e);
            setErrors(handleException(e));
            setLoading(false);
        }
    }

    const removeVoucher = async () => {
        if (!props.promotion_id) return;
        setLoading(true);
        try {
            await cartService.removePromotion(props.promotion_id);
            setLoading(false);
            if (props.onSuccess) props.onSuccess();
        } catch (e) {
            console.log(e);
            setErrors(handleException(e));
            setLoading(false);
        }
    }
    const isAvailableVoucher = (voucher: any) => {
        return true;
    }

    const useVoucher = async () => {
        if (props.promotion_id) {
            await removeVoucher();
        } else {
            if (!props.options) {
                setModal(true);
                return;
            }
            await addVoucher();
        }
    }

    const drawValidityDate = () => {
        let title = "";

        if (!voucher.active_from && voucher.active_to) {
            title = ` ${t("modules.voucher.field.valid_to.title")}: ${formatDate(DateHelper.fromString(voucher.active_to))}`
        }

        if (voucher.active_from && !voucher.active_to) {
            title = ` ${t("modules.voucher.field.valid_from.title")}: ${formatDate(DateHelper.fromString(voucher.active_from))}`
        }

        if (voucher.active_from && voucher.active_to) {
            title = ` ${t("modules.voucher.field.valid_from.title")}: ${formatDate(DateHelper.fromString(voucher.active_from))} ${t("modules.voucher.field.to.title")}: ${formatDate(DateHelper.fromString(voucher.active_to))}`
        }

        if (title) {
            return (
                <>
                    <CalendarSVG/>
                    {title}
                </>
            )
        }

        return <></>;
    }

    const drawButtons = () => {
        if (!voucher.supported_online) return <></>;

        return (
            props.options ? (
                <>
                    {props.promotion_id ? (
                        <button className={`btn text-danger btn-spinner${loading ? " loading" : ""}`}
                                aria-label={`${t("modules.voucher.action.remove_from_cart.title")} ${product.name}`}>
                            <span className="left spinner-border spinner-border-sm"></span>
                            {t("modules.voucher.action.remove_from_cart.title")}
                            <RemoveSVG/>
                        </button>
                    ) : (
                        <button className={`btn text-success btn-spinner${loading ? " loading" : ""}`}
                                aria-label={`${t("modules.voucher.action.to_cart.title")} ${product.name}`}>
                            <span className="left spinner-border spinner-border-sm"></span>
                            {t("modules.voucher.action.to_cart.title")}
                            <PlusSVG/>
                        </button>
                    )}
                </>
            ) : (
                <>
                    {props.promotion_id ? (
                        <button className={`btn text-danger btn-spinner${loading ? " loading" : ""}`}
                                aria-label={`${t("modules.voucher.action.remove_from_cart.title")} ${product.name}`}>
                            <span className="left spinner-border spinner-border-sm"></span>
                            {t("modules.voucher.action.remove_from_cart.title")}
                            <RemoveSVG/>
                        </button>
                    ) : (
                        <button className={`btn text-success btn-spinner${loading ? " loading" : ""}`}
                                aria-label={`${t("modules.voucher.action.use.title")} ${product.name}`}>
                            <span className="left spinner-border spinner-border-sm"></span>
                            {t("modules.voucher.action.use.title")}
                            <PlusSVG/>
                        </button>
                    )}
                </>
            )
        )
    }

    return (
        <>
            {modal && (
                <VoucherModal onHide={() => setModal(false)} show={true} voucher={voucher}
                              handlePromotionChange={handlePromotionChange}/>
            )}
            <div
                className={`voucher-card ${voucher.supported_online ? "success" : ""} flex-fill ` + (!isAvailableVoucher(voucher) ? ' disabled' : '')}
                onClick={useVoucher}>
                <div className={"card-content"}>
                    <div className="card-body">
                        <div className={"card-img"}>
                            {product.image ? (
                                <img src={product.image}
                                     className="card-img-top" alt={t("modules.voucher.field.voucher_image.title")}/>
                            ) : (
                                <GiftSVG/>
                            )}
                        </div>
                        <div className={"card-text-content"}>
                            <h5 className="card-title">{product.name}</h5>
                            <p className="card-text">{product.description}</p>
                        </div>
                    </div>
                    <div className="card-footer">
                         <span className={"valid-time"}>
                            {drawValidityDate()}
                         </span>
                        {drawButtons()}
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    menus: getMenus(state.menu),
    categories: getCategories(state.menu),
    promotions: getPromotions(state.menu),
    session: getSession(state.session),
    availabilities: getAvailabilities(state.menu),
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(VoucherSingleComponent));

